/**
 * Exportação CSV feita no cliente, a partir do que já está na tela.
 *
 * O BOM UTF-8 na frente é o que faz o Excel em português abrir "Fundação" em
 * vez de "FundaÃ§Ã£o" — sem ele, o operador acha que o sistema corrompeu o
 * relatório. O separador é `;`, que é o que o Excel pt-BR espera.
 */
export function downloadCsv(filename: string, rows: string[][]): void {
  const escape = (value: string) => `"${value.replace(/"/g, '""')}"`;
  const content = `\ufeff${rows.map((row) => row.map(escape).join(';')).join('\r\n')}`;
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
